<form name="form" role="form" (ngSubmit)="searchData()" #passwordForm="ngForm">
    <div class="serach-box">
        <input type="text" [(ngModel)]="searchQuery" class="search-box search-box-mobile" name="search">
    </div>
</form>